export class ListSparkEnginesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "sparkEngines",
            "baseName": "sparkEngines",
            "type": "Array<SparkEngine>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkEnginesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
